import { JoinOrSignInScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <JoinOrSignInScreen />;
}
